import { createStore } from 'satcheljs';
import { MailRouteState } from '../schema/MailRouteState';

const MAIL_ROUTE_INIT_STATE: MailRouteState = {
    routeType: null,
    itemId: null,
};

/**
 * This is an interim solution to solve for routing in mail using the current owa-router.
 * This should be removed once we move to react-router
 * Need: Rather than storing the route related information in domain specific store like mail-store
 * this store serves as one place to add the state information for route related state
 */
export const getMailRouteStore = createStore<MailRouteState>(
    'mailRouteStore',
    MAIL_ROUTE_INIT_STATE
);
